// Libs
import React, { Component } from 'react'
import { Container, Row, Col } from '../../components/Elemental'
import ReactCSSTransitionGroup from 'react-transition-group'
import { connect } from 'react-redux'

// CSS
import './styles.scss'

import withParams from '../../hoc/WithParams'

class Tour extends Component {
  render() {
    const { paramsSlide } = this.props

    return (
      <div className="tour">
        <Container className="tour__container">
          <Row>
            <Col>
              {React.cloneElement(this.props.children, { key: paramsSlide })}
            </Col>
          </Row>
        </Container>
      </div>
    )
  }
}

Tour = connect(
  (state, ownProps) => ({
    user: state.auth.user,
    paramsSlide: ownProps.params.slide,
  }))(Tour)

export default withParams(Tour)
